import { render, staticRenderFns } from "./CategoryUpdateDialogMetaData.vue?vue&type=template&id=265ea669&scoped=true"
import script from "./CategoryUpdateDialogMetaData.vue?vue&type=script&lang=ts"
export * from "./CategoryUpdateDialogMetaData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265ea669",
  null
  
)

export default component.exports